import { BACKEND_URL } from '../constants/api.js';

const ENDPOINT = `${BACKEND_URL}api/client-error`;

function safe(val, max) {
  return val != null ? String(val).slice(0, max) : undefined;
}

/**
 * Fire-and-forget: reports a client-side error to the backend for Loki ingestion.
 * Never throws - safe to call from error handlers and ErrorBoundary.
 *
 * @param {{ type: 'unhandledError'|'unhandledRejection'|'reactError', error: Error|unknown, componentStack?: string }}
 */
export function reportError({ type, error, componentStack }) {
  try {
    const payload = {
      type,
      message: safe(error?.message ?? String(error), 500),
      stack: safe(error?.stack, 2000),
      componentStack: safe(componentStack, 2000),
      url: safe(window.location.pathname, 200),
    };
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {}); // silence network failures - never block the UI
  } catch {
    // Never let the reporter itself crash anything
  }
}
